import React, { useCallback, useEffect, useState } from "react";
import { BsDoorOpen, BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { AiFillDelete, AiFillEye } from "react-icons/ai";
import { Box, useColorModeValue,Flex,Menu,MenuButton,MenuList,Circle,MenuItem, Icon} from "@chakra-ui/react";
import {columnsDataColumns,pendingDataColumns,rejectedDataColumns} from "../embrillTable/variables/colData";
import { useDispatch, useSelector } from "react-redux";
import PdfListModel from "components/models/PdfListModel";
import { poNumberFormate,currencyFormate } from "jsFunctions/helperFunctions";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { MdModeEdit } from "react-icons/md";
import { PiGraph } from "react-icons/pi";
import ExportDataModel from "components/exportData/ExportDataModel";
import { useLocation } from "react-router-dom";
import SpentAmountPopover from "components/models/spentAmountPopover";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { FaEllipsisV,FaList,FaPlus } from "react-icons/fa";
import {  CiExport, CiViewTable } from "react-icons/ci";
import { TbFileExport } from "react-icons/tb";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { useToasts } from "react-toast-notifications";
import PurchaseOrderForm from "components/allForm/PurchaseOrder/purchaseOrderForm";
import { fetchAsyncDeletePurchaseOrder } from "redux/purchaseOrder";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import prJson from "components/jsonData/purchase.json"
import ExpenseReports from "../expenseGraph";
import { fetchAsyncGetOrganizationModuleType } from "redux/organizationModuleSlice";
import OrganizationExpenseForm from "components/allForm/OrganizationExpenseForm/OrganizationExpenseForm";
import { fetchAsyncGetAllExpense,fetchAsyncDeleteOrgExpense,fetchAsyncHardDeleteExpense,fetchAsyncDeleteExpensePdf } from "redux/OrganizationExpenseSlice";
import CustomExpenseTable from "../embrillTable/CustomExpenseTable";
import ExpenseInfoModel from "components/models/ExpenseInfoModal";
import { fetchAsyncHardDeletePurchaseOrder } from "redux/purchaseOrder";
import { getSeletedIcon } from "components/allForm/OrgnizationProfile/expenseModule/moduleIcon";
import useSearch from "hooks/useSearch";
import { setFilteredData } from "redux/slices/searchTextSlice";

const OrganizationExpenseModule = () => {
  const [addNewModal, setAddNewModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [customEditModal, setCustomEditModal] = useState(null);
  const [moduleInfo, setModuleInfo] = useState({})
  const [customListData, setCustomListData] = useState([]);
  const [customPdfList, setCustomPdfList] = useState(null);
  const [showPdfList, setShowPdfList] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [activeDataList, setActiveDataList] = useState("approved");
  const [invoiceData, setInvoiceData] = useState([]);
  const [activeGraph, setActiveGraph] = useState(false);
  const [openCustomInfoModal, setOpenCustomInfoModal] = useState(false);
  const { startDate, endDate } = useSelector((state) => state.dateRange); 
  const {searchText} = useSelector((state) => state.searchValue);
  const {filteredListType} = useSelector((state) => state.filteredList);
  const location = useLocation();
  const { addToast } = useToasts();
  const [addPurchaseModal, setAddPurchaseModal] = useState(false);

  const { performSearch } = useSearch();

  const moduleType = useSelector((state) => state.moduleType);

  const currUser = useSelector((state) => state.auth.currUser);
  const expenseList = useSelector(
    (state) => state.expenseData?.customExpense
  );
  const expenseData = useSelector(
    (state) => state.expenseData
  );
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === moduleInfo?.name);
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [moduleInfo,currUser]);

  const dispatch = useDispatch();
  const handleModalOpen = () => {
    setAddNewModal(true);
  };
  const handleOpenPurchaseModal = () => {
    setAddPurchaseModal(true);
  };
  const handleModalClose = (active) => {
    setAddNewModal(false);
    setOpenEditModal(false);
    setCustomEditModal(null);
    handlerRefreshData();
    if(active){
      setActiveDataList(active)
    }
  };

  const handleClosePurchaseModal = (active) => {
    setAddPurchaseModal(false);
    setOpenEditModal(false);
    setCustomEditModal(null);
    handlerRefreshData();
    if(active){
      setActiveDataList(active)
    }
  };
  
  useEffect(() => {
    dispatch(fetchAsyncGetOrganizationModuleType())
  }, []);

  useEffect(()=>{
    if(moduleInfo && moduleInfo?._id){
      const data = {
        moduleId:moduleInfo?._id,
        moduleType:moduleInfo?.name
      }
      setLoading(true); 
      dispatch(fetchAsyncGetAllExpense(data)).then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        setLoading(false); 
      });
    }
  },[moduleInfo])

  const pathSegments = location.pathname.split('/'); 
  const id = pathSegments[pathSegments.length - 1]; 

  useEffect(()=>{
    if(moduleType && moduleType?.length){
      const module = moduleType.find((item)=> item?._id === id)
      setModuleInfo(module)
    }
  },[id])

  const deleteFileFromList = (sendData) => {
    const data = {
      ...sendData,
      moduleId:moduleInfo._id,
     
    };
    dispatch(fetchAsyncDeleteExpensePdf(data)).then((response) => {
      handlerRefreshData();
    });
  };

  const [openMenu, setOpenMenu] = useState(false);

  const handleOpenMenu = () => {
    setOpenMenu(!isOpen);
  };

  const handleCreateNewPR = () => {
    setOpenMenu(false);
    handleModalOpen()
  };

  const handleNewPurchaseOrder = () => {
    setOpenMenu(false);
    handleOpenPurchaseModal()

  };
 

  const getAllCustomData = (listData) => {

    if (listData && listData.length > 0) {
      const tableData = listData.map((data, index) => {
        let isGst = data?.gstApl?.sts;
        let isTds = data?.tdsApl?.sts;
        let foundInvoiceWithLength = false;
        const array = data?.pyInfo?.list || [];
        const invArray = data?.pyInfo?.inv || [];
        const spentAmounts = array.map(item => parseFloat(item?.amt || 0)); 
        const totalSpent = array.reduce((acc, item) => acc + (parseFloat(item?.amt) || 0), 0);
        
        const refundAmount = data?.rfdInfo?.list || [];
        const totalRefund = refundAmount.reduce(
          (acc, item) => acc + (parseFloat(item?.amt) || 0),
          0
        );

        if (invArray && invArray.length > 0) {
          foundInvoiceWithLength = true;
        }

        return {
          _id: data._id,
          no: index + 1,
          poNo: (
            <span style={{ cursor: "pointer", color: "blue" }}>
              {data.poNo && poNumberFormate(data.poNo)}
            </span>
          ),
          purchasedate: dateTimeFormat(data.oDt),
          majorType: (
            <span style={{ cursor: "pointer" }}>{data?.mjId?.val}</span>
          ),
          minorType: (
            <span style={{ cursor: "pointer" }}>{data?.mnId?.val}</span>
          ),

          merchantName: (
            <span style={{ cursor: "pointer" }}>
              {data?.mrId?.name || data?.resId?.name}
            </span>
          ),
          sortSpentAmt: totalSpent
            ? parseFloat(totalSpent) - parseFloat(totalRefund || 0)
            : 0,

          spentAmount: (
            <Box display="flex">
              <span
                style={{ cursor: "pointer", width: "90px" }}
                className={
                  parseFloat(totalSpent) - parseFloat(totalRefund)
                    ? "green"
                    : ""
                }
              >
                {formatAmountInINR(
                  totalSpent
                    ? parseFloat(totalSpent) - parseFloat(totalRefund || 0)
                    : 0
                )}
              </span>

              <SpentAmountPopover
                spentAmounts={spentAmounts}
                refundAmount={refundAmount}
              />
            </Box>
          ),
          sortReqAmt: Number(data.pyInfo?.apAmt) || 0,
          approvalAmount: (
            <span
              style={{ cursor: "pointer" }}
              className={data.pyInfo?.sts !== 1 ? "red" : "green"}
            >
              {data.pyInfo?.apAmt ? (
                currencyFormate(data.pyInfo?.apAmt)
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: `<span style="font-family: sans-serif">₹</span> ${Number(
                      0
                    ).toFixed(2)}`,
                  }}
                />
              )}
            </span>
          ),
          sortApdAmt: data.pyInfo?.tlAmt || 0,
          approvedAmount: (
            <Box display="flex" alignItems="self-start">
              <span style={{ cursor: "pointer", width: "100px" }}>
                {data.pyInfo?.tlAmt ? (
                  currencyFormate(data.pyInfo?.tlAmt)
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `<span style="font-family: sans-serif">₹</span> ${Number(
                        0
                      ).toFixed(2)}`,
                    }}
                  />
                )}
              </span>
              {isGst ? (
                <Circle
                  title="GST Applicable"
                  className="mx-1 my-1 gt-tag"
                  size="3"
                >
                  G
                </Circle>
              ):""}
              {isTds ? (
                <Circle
                  title="TDS Applicable"
                  className="mx-1 my-1 gt-tag"
                  size="3"
                >
                  T
                </Circle>
              ):""}
            </Box>
          ),
          invoice: foundInvoiceWithLength ? (
            <BsFillFileEarmarkPdfFill
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                setShowPdfList(true);
                setCustomPdfList(data);
              }}
            />
          ) : (
            <BsFillFileEarmarkPdfFill
              style={{ cursor: "not-allowed" }}
              color="gray"
            />
          ),
          status: "Rejected",
          action: (
            <div className="d-flex">
              <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleRowClick(e, data._id);
                }}
              />
              <AiFillEye
                className="me-2"
                color="#000D55"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedItem(data);
                  setOpenCustomInfoModal(true);
                }}
              />
              {role === "Admin" ? (
                <>
                  <AiFillDelete
                    style={{ cursor: "pointer" }}
                    size={16}
                    onClick={(e) => {
                      e.preventDefault();
                      const title = prJson.confirm.deleteExpense.replace(
                        "{poNumber}",
                        data.poNo ? poNumberFormate(data.poNo) : ""
                      );
                      ConfirmationDialog({
                        title: title,
                        text: prJson.text.undone,
                        icon: "warning",
                        confirmButtonText: "Delete",
                        cancelButtonText: "Cancel",
                        onConfirm: () => {
                          deleteExpenseData(data);
                        },
                      });
                    }}
                  />
                  <AiFillDelete
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: "3px",
                    }}
                    size={16}
                    onClick={(e) => {
                      e.preventDefault();
                      const title = prJson.confirm.deleteExpense.replace(
                        "{poNumber}",
                        data.poNo ? poNumberFormate(data.poNo) : ""
                      );
                      ConfirmationDialog({
                        title: title,
                        text: prJson.text.undone,
                        icon: "warning",
                        confirmButtonText: "Delete",
                        cancelButtonText: "Cancel",
                        onConfirm: () => {
                          hardDeleteExternalData(data);
                        },
                      });
                    }}
                  />
                </>
              ) : null}
            </div>
          ),
        };
      });
      setCustomListData(tableData);
      if (customPdfList) {
        const dataGet = expenseList.filter(
          (item) => item._id === customPdfList._id
        );
        setCustomPdfList(dataGet[0]);
      }
      if (customEditModal) {
        const dataGet = expenseList.filter(
          (item) => item._id === customEditModal._id
        );
        setCustomEditModal(dataGet[0]);
      }
    } else {
      setCustomListData([]);
    }
  };

  const handleExpenseListData = () => {
    if (!expenseList || expenseList.length === 0) {
      setCustomListData([]);
      return;
    }
    const listData = expenseList.filter((item) => {
      if (activeDataList === "approved") {
        return item.pyInfo.sts === 1;
      }
      if (activeDataList === "pending") {
        return item.pyInfo.sts === 0

      }
      return item.pyInfo.sts === 2

    });
    getAllCustomData(listData);
  };

  useEffect(() => {
    handleExpenseListData();
  }, [expenseList, activeDataList]);

  useEffect(() => {
    if (customPdfList) {
      const dataGet = expenseList.filter(
        (item) => item._id === customPdfList._id
      );
      const data = dataGet[0];
      let invoices = data?.pyInfo?.inv || [];
      setInvoiceData(invoices);
      setCustomPdfList(dataGet[0]);
    }
  }, [customPdfList]);

  const deleteExpenseData = (data) => {
    const pono = poNumberFormate(data.poNo)
    if(data.catId === moduleInfo?._id){
      setLoading(true)
      dispatch(fetchAsyncDeletePurchaseOrder(data._id)).then(() => {
        handlerRefreshData();
        const msg = prJson.success.deletedPo.replace("{pono}",pono)
        addToast(msg, { appearance: "success" });      
        setLoading(false)
      }).catch((err)=>{
        setLoading(false)
        addToast(prJson.faield.deletedPo, { appearance: "error" });
      });;
    }
    else{

      setLoading(true)
      dispatch(fetchAsyncDeleteOrgExpense({moduleId:moduleInfo?._id,id:data._id})).then(() => {
        handlerRefreshData();
        const msg = prJson.success.deletedPr.replace("{prno}",pono)
        addToast(msg, { appearance: "success" });      
        setLoading(false)
      }).catch((err)=>{
        setLoading(false)
        addToast(prJson.failed.deletedPr, { appearance: "error" });
      });;
    }
  };

  const hardDeleteExternalData = (data) => {
    const pono = poNumberFormate(data.poNo)
   
    const objData = {
      id: data._id,
      moduleId: moduleInfo?._id
    };
    if(data.catId === moduleInfo?._id){
      setLoading(true)
      dispatch(fetchAsyncHardDeletePurchaseOrder(data?._id)).then((res) => {
        handlerRefreshData();
        const msg = prJson.success.deletedPo.replace("{pono}",pono)
          addToast(msg, { appearance: "success" });           
          setLoading(false)
      }).catch((err)=>{
        setLoading(false)
        addToast(prJson.failed.deletedPr, { appearance: "error" });
  
      });
    }
    else{
      setLoading(true)
      dispatch(fetchAsyncHardDeleteExpense(objData)).then((res) => {
        handlerRefreshData();
        const msg = prJson.success.deletedPr.replace("{prno}",pono)
          addToast(msg, { appearance: "success" });           
          setLoading(false)
      }).catch((err)=>{
        setLoading(false)
        addToast(prJson.failed.deletedPr, { appearance: "error" });
  
      });
    }
  };

  const handleListViewType = (type)=>{
    // dispatch(setFilteredData({ filteredListType:type}));
    performSearch(searchText, startDate, endDate,type);
  }
  
  const handlerRefreshData = useCallback(() => {
    performSearch(searchText, startDate, endDate);
  }, [searchText,startDate, endDate,performSearch]);

  const handleGraph = () => {
    setActiveGraph(true);
  };
  const handleTable = () => {
    setActiveGraph(false);
  };

  const handleRowClick = (e, _id) => {
    e.preventDefault();
    const data = expenseList.find((item) => item?._id === _id);
    if(data.catId === moduleInfo?._id){
      handleOpenPurchaseModal();
    }
    else{
      handleModalOpen();
    }
    setOpenEditModal(true);
    setCustomEditModal(data);
  };

  const closeExpenseInfoModal = () => {
    setOpenCustomInfoModal(false);
    setSelectedItem({});
  };

  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  
  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn,setActiveBtn] = useState("")

  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn)
  };
  const handleClose = () => {   
    setActiveBtn("");   
    setIsOpen(false)
  };

   if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box display="flex" className="mx-0" justifyContent="space-between">
        <Box display="flex" justifyContent="space-between" className="tab-btn mx-2">
        {!activeGraph &&
          <Box className="tab-btn-div">
            <div
              className={`div-btn ${
                activeDataList === "approved" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveDataList("approved")}
            >
              Approved
            </div>
            <div
              className={`div-btn ${
                activeDataList === "pending" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveDataList("pending")}
            >
              Pending
            </div>
            <div
              className={`div-btn ${
                activeDataList === "rejected" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveDataList("rejected")}
            >
              Rejected
            </div>
          </Box>
        }
        </Box>

        <div 
        className="graph_button internal-graph-btn mx-2"        
       >
        <button title="Data View" className={`graph_icon_button ${!activeGraph ? 'active_graph' : ''}`}  onClick={()=>handleTable()}><CiViewTable  /></button>
        {role !== 'Accountant' ?
        <button  title="Analytics View" className={`graph_icon_button ${activeGraph ? 'active_graph' : ''}`} onClick={()=>handleGraph()}><PiGraph/></button>
        :
        <button title="Analytics View"  className={`graph_icon_button ${activeGraph ? 'active_graph' : ''}`} style={{opacity:'0.3',cursor:'not-allowed'}}><PiGraph/></button>
        }
        
       </div>
       
       {!activeGraph && 
       
        <Box display="flex" mt={2} className="add-new-btn ">
          <Menu>
              <MenuButton
                onClick={handleOpenMenu}
                className="view-menu-btn"
              >
                <Box display="flex">
                  <FaList size={18} className="view-icon-btn" />{" "}
                </Box>
              </MenuButton>
              {openMenu && (
                <MenuList className="menu-list view-menu-list">
                  <MenuItem
                    className={`menu-item ${filteredListType === 'all' ? 'active-item' : ''}`}
                    onClick={()=>handleListViewType('all')}
                  >
                    All
                  </MenuItem>
                  <MenuItem
                    className={`menu-item ${filteredListType === 'requestList' ? 'active-item' : ''}`}
                    onClick={()=>handleListViewType('requestList')}

                  >
                    Purchase Request
                  </MenuItem>
                  <MenuItem
                    className={`menu-item ${filteredListType === 'orderList' ? 'active-item' : ''}`}
                    onClick={()=>handleListViewType('orderList')}

                  >
                    Purchase Order
                  </MenuItem>
                </MenuList>
              )}
            </Menu>
          <Menu>
              <MenuButton
                onClick={handleOpenMenu}
                className="new-btn add-new-menu-btn"
              >
                <Box display="flex">
                  <FaPlus size={12} className="new-plus-icon" />{" "}
                  <span>New</span>
                </Box>
              </MenuButton>
              {openMenu && (
                <MenuList className="menu-list">
                  <MenuItem
                    className={`menu-item`}
                    onClick={handleCreateNewPR}
                  >
                    Create Purchase Request
                  </MenuItem>
                  <MenuItem
                    className={`menu-item`}
                    onClick={handleNewPurchaseOrder}
                  >
                    Create Purchase Order
                  </MenuItem>
                </MenuList>
              )}
            </Menu>
          <Box>
          <Menu>
          <MenuButton p="0px">
          <Box  className='menu-ellipsis-btn'><FaEllipsisV /></Box>

          </MenuButton>
          <MenuList
             boxShadow={shadow}
             p="0px"
             borderRadius="10px"
             bg={menuBg}
             border="none"
          >
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pt="10px"
                pb="8px"
                className="menu-text"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                onClick={()=>toggleMenu('xlsx')}
                display="flex"
               
              >
                <CiExport size={20} className="mx-1"/> <span>Export XLSX</span>
                
              </Box>
             
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            
             
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pb="8px"
                pt="5px"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                display="flex"
                className="menu-text"
                onClick={()=>toggleMenu('invoice')}


              >
                <TbFileExport size={20} className="mx-1"/> 
                <span>Export Invoice</span>
                
              </Box>
            </Flex>
           <Box marginRight={40}>
           {isOpen && (
            <ExportDataModel
              filename={`${moduleInfo.name}_`}
              type="custom"
              role={role}
              isOpen={isOpen}
              handleClose={handleClose}
              activeBtn={activeBtn}
              moduleId={moduleInfo?._id}
            />
          )}
           </Box>
          </MenuList>
        </Menu>
          </Box>
        </Box>
      }
      </Box>
     
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>

        {activeGraph ? (
          <Box className={`graph-card ${activeGraph ? "graph_active" : ""}`}>
            <ExpenseReports
              name={`${moduleInfo?.name} Total Expense`}
              heading={moduleInfo?.name}
              icon = {moduleInfo?.icnImg && getSeletedIcon(moduleInfo.icnImg) ? 
          getSeletedIcon(moduleInfo.icnImg):<Icon w="22px" h="22px" as={BsDoorOpen} />}
              role={role}
              moduleId={moduleInfo?._id}
              type={moduleInfo?.name}
              moduleType={moduleInfo?.typ}

            />
          </Box>
        ) : (
          <CustomExpenseTable
            columnsData={
              activeDataList === "rejected"
                ? rejectedDataColumns
                : activeDataList === "pending"
                ? pendingDataColumns
                : columnsDataColumns
            }
            tableData={customListData}
            openInfoModal={handleRowClick}
            expenseType={moduleInfo?.name}
            type={moduleInfo?.name}
            activeDataList={activeDataList}
            role={role}
            paymentData = {expenseData}
            chnageDataList={(value)=>setActiveDataList(value)}

          />
        )}
      {addNewModal && (
        <OrganizationExpenseForm
          openExpenseModal={addNewModal}
          closeExpenseModal={handleModalClose}
          isEdit={openEditModal}
          editData={customEditModal}
          refreshEditData={handlerRefreshData}
          activeList={activeDataList}
          role={role}
          expenseType={moduleInfo?.name}
          moduleInfo={moduleInfo}
          prefix= {moduleInfo.prfx}

        />
      )}
      </Box>

      {showPdfList && (
        <PdfListModel
          pdfData={customPdfList ? invoiceData : []}
          currentId={customPdfList ? customPdfList._id : ""}
          openModal={showPdfList}
          closeModal={() => {
            setShowPdfList(false);
            setCustomPdfList(null);
          }}
          deleteFileFromList={deleteFileFromList}
          role={role}
        />
      )}
      {openCustomInfoModal && (
        <ExpenseInfoModel
          openInfoModal={openCustomInfoModal}
          closeInfoModal={closeExpenseInfoModal}
          selectedItem={selectedItem}
          role={role}
          expenseType={moduleInfo?.name}
        />
      )}
      {addPurchaseModal && (
        <PurchaseOrderForm
          openPurchaseModal={addPurchaseModal}
          ClosePurchaseModal={handleClosePurchaseModal}
          isEdit={openEditModal}
          editData={customEditModal}
          refreshEditData={handlerRefreshData}
          activeList={activeDataList}
          role={role}
          expenseType="PurchaseOrder"
          prefix={moduleInfo?.poPrfx}
          moduleInfo={moduleInfo}



        />
      )}
    </>
  );
};

export default OrganizationExpenseModule;
